export default "__VITE_ASSET__DQVLYRBN__"